import { render, staticRenderFns } from "./TenantUserNotes.vue?vue&type=template&id=004c0762&scoped=true"
import script from "./TenantUserNotes.vue?vue&type=script&lang=js"
export * from "./TenantUserNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c0762",
  null
  
)

export default component.exports